var global = require("./shim/global.js");
function f788(p5894) {
  if (p5894 && p5894.Math == Math) {
    return p5894;
  } else {
    return undefined;
  }
}
const a = typeof globalThis == "object" && f788(globalThis) || typeof window == "object" && f788(window) || typeof self == "object" && f788(self) || typeof global == "object" && f788(global) || function () {
  return this;
}() || {};
exports.a = a;
function b() {
  return a;
}
exports.b = b;
function c(p5895, p5896, p5897) {
  const v4909 = p5897 || a;
  const v4910 = v4909.__SENTRY__ = v4909.__SENTRY__ || {};
  const v4911 = v4910[p5895] ||= p5896();
  return v4911;
}
exports.c = c;